export class PassCard {
  usuario: string;
  constrasenia: string;
  expirationDateToken?: Date;
  issuedDate?: Date;
  tokenType?: number;
  tokenData?: string;
  idUser?: number;
  IdPerfil?: number;
  LstModulos: itmMenu[];
  LstCategoriasModulos: itmCategoria[];
  IdIdioma: number;
  blnTerminosCondiciones: boolean;
  blnCambiarPassword: boolean;

  constructor(usr: string, pass: string) {

    this.usuario = usr;
    this.constrasenia = pass;
  }
}




export class WMSToken {

  IdToken: number;
  IsValid: boolean;
  TokenData: string;
  TokenType: number;
  IdUser: number;
  IdUserWMS: number;
  IdPerfilWMS: number;
  LstModulos: itmMenu[];
  IdModule: number;
  StartPage: string;
  IssuedDate: Date;
  ExpirationDateToken: Date;
  FechaBloqueo: Date;
  FechaPasswordUltimo: Date;
  Mensaje: number;
  Intentos: number;
  IsNotBlocked: boolean;
  IdIdioma: number;
  NombreUsuario: string;
  blnTerminosCondiciones: boolean;
  blnCambiarPassword: boolean;

}


// tslint:disable-next-line:class-name
export class itmMenu {
  title: string;
  component: string;
  strIcono: string;
  IdCategoriaModulo: number;
  strCategoriaModulo: string;
  selected: boolean;
}

// tslint:disable-next-line:class-name
export class itmCategoria {
  IdCategoriaModulo: number;
  strCategoriaModulo: string;
  LstModulos: itmMenu[];
  opened: boolean;
}
